import React, { useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { MobileContext, CurrencyContext } from 'context';
import { LOCAL_STORAGE_PREFIX, FIAT_CURRENCIES } from 'const';
import { NetworkCurrencySymbol } from 'components/CurrencySymbols';
import './styles.scss';


export default function CurrencySwitcher(props) {
  const { currencyID, SetCurrencyID } = useContext(CurrencyContext);
  const isMobile = useContext(MobileContext);

  function SwitchToCryptoCurrency() {
    SetCurrencyID(0);
    localStorage.setItem(LOCAL_STORAGE_PREFIX + 'currency', 0)
  };

  function SwitchFiatCurrency() {
    let nextCurrency = Number(currencyID) + 1;
    if (nextCurrency >= FIAT_CURRENCIES.length) {
      nextCurrency = 1;
    }
    SetCurrencyID(nextCurrency);
    localStorage.setItem(LOCAL_STORAGE_PREFIX + 'currency', nextCurrency)
  }

  /*
  console.log({
    a: currencyID == 0 ? 1 : currencyID,
    b: FIAT_CURRENCIES[currencyID == 0 ? 1 : currencyID]?.icon,
  });
  */

  if (props.disabled)
    return null;
  else
    return (<div className={'SwitchCurrency' + (isMobile ? ' Mobile' : '')}>
      <div className={Number(currencyID) ? 'active' : 'inactive'} onClick={SwitchFiatCurrency}>
        <div className='SwitchItem Padded'>
          <FontAwesomeIcon icon={FIAT_CURRENCIES[currencyID == 0 ? 1 : currencyID]?.icon} />
        </div>
      </div>
      <div onClick={SwitchToCryptoCurrency}>
        <div className='SwitchItem'>
          <NetworkCurrencySymbol />
        </div>
      </div>
    </div>);
}